import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Button } from "../components/ui/button";
// import { Card } from "../components/ui/card";
// import { MapPin } from "lucide-react";

const Home = () => {
    // const navigate = useNavigate();
    const [formData, setFormData] = useState({
        mobile: "",
        zipcode: "",
        store: "",
        name: "",
        email: "",
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const stores = ["Sunnyvale", "Milpitas", "Fremont"];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        if (!formData.mobile || !formData.zipcode || !formData.store) {
            setMessage({
                type: "error",
                text: "Please fill in all required fields.",
            });
            setLoading(false);
            return;
        }

        try {
            const backendBaseUrl =
                process.env.REACT_APP_MARKETING_BACKEND_URL ||
                "https://marketing.apnimandi.us/api";
            const cleanBaseUrl = backendBaseUrl.replace(/\/$/, "");

            const response = await fetch(
                `${cleanBaseUrl}/customers/subscribe`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        phone: formData.mobile,
                        mobile: formData.mobile,
                        storeName: formData.store,
                        store: formData.store,
                        zipcode: formData.zipcode,
                        name: formData.name,
                        email: formData.email,
                    }),
                },
            );

            const data = await response.json();

            if (response.ok) {
                setMessage({
                    type: "success",
                    text: "Successfully signed up! You will receive offers shortly.",
                });
                setFormData({
                    mobile: "",
                    zipcode: "",
                    store: "",
                    name: "",
                    email: "",
                });
            } else {
                setMessage({
                    type: "error",
                    text:
                        data.message ||
                        "Something went wrong. Please try again.",
                });
            }
        } catch (error) {
            console.error("Signup error:", error);
            setMessage({
                type: "error",
                text: "Failed to connect to the server.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 font-sans">
            {/* Main Content */}
            <main className="container mx-auto px-4 py-8 md:py-12 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-24">
                {/* Left Side - Promotional Text */}
                <div className="flex-1 text-center lg:text-left space-y-6 max-w-2xl">
                    {/* Logo for mobile - clearly visible */}
                    <div className="lg:hidden mb-8 flex justify-center">
                        <img
                            src="/apnimandi.png"
                            alt="ApniMandi Logo"
                            className="h-24 w-auto object-contain drop-shadow-sm"
                        />
                    </div>

                    <div className="relative">
                        {/* Decorative element */}
                        <div className="absolute -left-10 -top-10 w-20 h-20 bg-orange-100 rounded-full blur-xl opacity-60 animate-pulse"></div>

                        <h1 className="relative text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-tight">
                            <span className="text-[#2E7D32]">
                                Exclusive Savings
                            </span>{" "}
                            <br />
                            <span className="text-[#2E7D32]">Ahead!</span>
                        </h1>
                    </div>

                    <p className="text-lg md:text-xl text-slate-600 leading-relaxed font-medium">
                        Sign up now to unlock special offers and discounts only
                        for our subscribers.
                    </p>

                    {/* Decorative bottom icons/illustration placeholder */}
                    <div className="hidden lg:block mt-12 pt-8 border-t border-slate-200/60">
                        <div className="flex gap-4 opacity-80">
                            {/* You can add small icons here if desired, otherwise just spacing */}
                            <div className="h-2 w-12 bg-[#F57C00] rounded-full"></div>
                            <div className="h-2 w-8 bg-[#2E7D32] rounded-full"></div>
                            <div className="h-2 w-4 bg-[#F57C00] rounded-full"></div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Form Card */}
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-100 relative">
                        {/* Card Header with Logo */}
                        <div className="pt-8 pb-2 flex justify-center bg-white">
                            <img
                                src="/apnimandi.png"
                                alt="Apni Mandi"
                                className="h-20 object-contain"
                            />
                        </div>

                        <div className="p-8 pt-4">
                            {/* Form */}
                            <form onSubmit={handleSubmit} className="space-y-4">
                                {/* Mobile Number */}
                                <div className="space-y-1">
                                    <label
                                        htmlFor="mobile"
                                        className="block text-sm font-semibold text-slate-700"
                                    >
                                        Mobile Number{" "}
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        id="mobile"
                                        name="mobile"
                                        type="tel"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        placeholder="Enter mobile number"
                                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#F57C00] focus:border-transparent outline-none transition-all placeholder:text-slate-400 text-slate-800 bg-slate-50 focus:bg-white"
                                        required
                                    />
                                </div>

                                {/* Zipcode */}
                                <div className="space-y-1">
                                    <label
                                        htmlFor="zipcode"
                                        className="block text-sm font-semibold text-slate-700"
                                    >
                                        Zipcode{" "}
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        id="zipcode"
                                        name="zipcode"
                                        type="text"
                                        value={formData.zipcode}
                                        onChange={handleChange}
                                        placeholder="Enter zipcode"
                                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#F57C00] focus:border-transparent outline-none transition-all placeholder:text-slate-400 text-slate-800 bg-slate-50 focus:bg-white"
                                        required
                                    />
                                </div>

                                {/* Preferred Store */}
                                <div className="space-y-1">
                                    <label
                                        htmlFor="store"
                                        className="block text-sm font-semibold text-slate-700"
                                    >
                                        Preferred Store{" "}
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <div className="relative">
                                        <select
                                            id="store"
                                            name="store"
                                            value={formData.store}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#F57C00] focus:border-transparent outline-none transition-all appearance-none bg-slate-50 focus:bg-white text-slate-800"
                                            required
                                        >
                                            <option value="" disabled>
                                                Select your preferred store
                                            </option>
                                            {stores.map((store) => (
                                                <option
                                                    key={store}
                                                    value={store}
                                                >
                                                    {store}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-500">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M19 9l-7 7-7-7"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Name */}
                                <div className="space-y-1">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-semibold text-slate-700"
                                    >
                                        Name
                                    </label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Enter your name"
                                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#F57C00] focus:border-transparent outline-none transition-all placeholder:text-slate-400 text-slate-800 bg-slate-50 focus:bg-white"
                                    />
                                </div>

                                {/* Email */}
                                <div className="space-y-1">
                                    <label
                                        htmlFor="email"
                                        className="block text-sm font-semibold text-slate-700"
                                    >
                                        Email
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Enter email"
                                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#F57C00] focus:border-transparent outline-none transition-all placeholder:text-slate-400 text-slate-800 bg-slate-50 focus:bg-white"
                                    />
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className={`w-full py-4 px-6 rounded-xl text-white font-bold text-lg shadow-lg transform transition-all duration-200 
                                        ${
                                            loading
                                                ? "bg-slate-400 cursor-not-allowed"
                                                : "bg-[#F57C00] hover:bg-[#EF6C00] hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0"
                                        }`}
                                >
                                    {loading ? (
                                        <div className="flex items-center justify-center gap-2">
                                            <div className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                            <span>Submitting...</span>
                                        </div>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>

                                {message && (
                                    <div
                                        className={`p-4 rounded-xl text-sm font-medium ${message.type === "success" ? "bg-green-50 text-green-700 border border-green-100" : "bg-red-50 text-red-700 border border-red-100"}`}
                                    >
                                        {message.text}
                                    </div>
                                )}
                            </form>

                            <div className="mt-6 text-xs text-slate-500 text-center leading-relaxed">
                                By submitting this form, you agree to receive
                                recurring promotional and personalized marketing
                                text messages. Consent is not a condition of any
                                purchase. Terms and Service.
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Bottom Decorative Pattern/Illustration */}
            <div className="fixed bottom-0 left-0 right-0 h-24 bg-[url('https://files.catbox.moe/0v251w.png')] bg-contain bg-bottom bg-repeat-x opacity-100 pointer-events-none z-0">
                {/* Placeholder for the bottom footer illustration seen in the screenshot */}
            </div>

            {/* Simple footer needed for spacing */}
            <div className="h-24 md:h-32"></div>
        </div>
    );
};

export default Home;
